<template>
	<div>
		<div class="row-form">
			<div class="form-content">
				<form action="" @submit.prevent="">

					<div class="form-row d-none">
						<div class="form-group col-12 search">
							<div class="input-group">
								<div class="input-group-prepend">
									<span class="input-group-text">
										<svg viewBox="0 0 20 20"><use xlink:href="/img/icons/search.svg#Symbols" href="/img/icons/search.svg#Symbols"></use></svg>
									</span>
								</div>
								<input type="text" class="form-control" :placeholder="placeholder" id="searchBox">
								<a href="#" class="btn btn-white d-sm-none">
									<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
										<path d="M504 384H192v-40c0-13.3-10.7-24-24-24h-48c-13.3 0-24 10.7-24 24v40H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h88v40c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24v-40h312c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8zm-344 64h-32v-96h32v96zM504 96H256V56c0-13.3-10.7-24-24-24h-48c-13.3 0-24 10.7-24 24v40H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h152v40c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24v-40h248c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8zm-280 64h-32V64h32v96zm280 80h-88v-40c0-13.3-10.7-24-24-24h-48c-13.3 0-24 10.7-24 24v40H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h312v40c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24v-40h88c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8zm-120 64h-32v-96h32v96z"></path>
									</svg>
								</a>
							</div>
						</div>
					</div>

					<div class="form-row">

						<div class="form-group center row-calendar">
							<a href="#" @click.prevent="openCalendar()">
								<div class="input-group calendar-group d-none d-sm-flex">
									<div class="input-group-prepend">
										<span class="input-group-text color-red">
											<svg><use xlink:href="/img/icons/calendar.svg#Symbols" href="/img/icons/calendar.svg#Symbols"></use></svg>
										</span>
									</div>
									<input type="text" id="calendar" class="form-control no-l-border" :value="showDate" readonly>
								</div>
							</a>
							<a href="#" @click.prevent="openCalendar()" class="color-red d-sm-none calendar-link">
								<svg><use xlink:href="/img/icons/calendar.svg#Symbols" href="/img/icons/calendar.svg#Symbols"></use></svg>
							</a>
							<datepicker
                                ref="restoSearchCalendar"
                                name="calendar-picker"
                                :format="customFormatter"
                                :language="lang"
                                :monday-first="true"
                                input-class="calendar-picker d-none"
                                calendar-class="calendar-opened"
                                :bootstrap-styling="true"
                                :minimumView="'day'"
                                :maximumView="'day'"
                                :value="selectedDate"
                            >
							</datepicker>
						</div>

						<div class="form-group row-kitchen">
							<select class="form-control custom-select" @change="applyKitchenFilter">
								<option :value="null" selected>{{ trad.kitchen }}</option>
								<option :value="item.value" v-for="item in kitchenFacets" :selected="item.isRefined">{{ item.label }} ({{ item.count }})</option>
							</select>
						</div>

						<div class="form-group row-type d-none d-sm-block">
							<select class="form-control custom-select" @change="applyGastronomicFilter">
								<option :value="null" selected>{{ trad.type }}</option>
								<option :value="item.value" v-for="item in gastronomicFacets" :selected="item.isRefined">{{ trans.get('places-search.'+item.label) }} ({{ item.count }})</option>
							</select>
						</div>

						<div class="block-promo-filter d-none d-sm-flex">
							<div class="form-group row-promo d-none d-sm-block">
								<select class="form-control custom-select" v-model="promoFilter" ref="promoSelect1">
									<option :value="null" selected>{{ trad.promo }}</option>
									<option value="50">{{ trad.promo_50 }}</option>
									<option value="40">{{ trad.promo_40 }}</option>
									<option value="30">{{ trad.promo_30 }}</option>
									<option value="20">{{ trad.promo_20 }}</option>
									<option value="10">{{ trad.promo_10 }}</option>
								</select>
							</div>

							<div class="form-group more d-none d-sm-block">
								<a href="#" class="d-none d-sm-block" @click.prevent="resetFilters">{{ trad.clear_filters }}</a>
								<a href="#" class="d-sm-none" @click.prevent="resetFilters">{{ trad.clear_filters_mobile }}</a>
							</div>
						</div>

						<div class="form-group more d-sm-none">
							<!-- <a href="#" v-b-toggle.filter_collapse class="d-none d-sm-block">
								<span class="when-opened">{{ trad.less_filter }}</span>
								<span class="when-closed">{{ trad.more_filter }}</span>
							</a> -->
							<a href="" v-b-toggle.filter_collapse @click.prevent="">
								<span class="when-opened">{{ trad.less_filter_mobile }}</span>
								<span class="when-closed">{{ trad.more_filter_mobile }}</span>
							</a>
						</div>

					</div>
				</form>
			</div>
		</div>

		<b-collapse id="filter_collapse">
			<div class="navbar-nav" id="filter-nav">
				<div class="mobile-content">
					<div class="form-row">
						<div class="form-group row-type">
							<select class="form-control custom-select" @change="applyGastronomicFilter">
								<option :value="null" selected>{{ trad.type }}</option>
                                <option :value="item.value" v-for="item in gastronomicFacets" :selected="item.isRefined">{{ trans.get('places-search.'+item.label) }} ({{ item.count }})</option>
							</select>
						</div>

						<div class="form-group row-promo">
							<select class="form-control custom-select" v-model="promoFilter" ref="promoSelect2">
								<option :value="null" selected>{{ trad.promo }}</option>
								<option value="50">{{ trad.promo_50 }}</option>
								<option value="40">{{ trad.promo_40 }}</option>
								<option value="30">{{ trad.promo_30 }}</option>
								<option value="20">{{ trad.promo_20 }}</option>
								<option value="10">{{ trad.promo_10 }}</option>
							</select>
						</div>

						<div class="form-group more">
							<a href="" class="btn btn-white w-100 mt-0" @click.prevent="hideCollapse">{{ trad.apply_filters }}</a>
						</div>
						<div class="form-group more center">
							<a href="" class="w-100 mt-0" @click.prevent="resetFiltersAndCollapse">{{ trad.clear_filters }}</a>
						</div>
					</div>
				</div>
			</div>
		</b-collapse>

		<div class="row row-search">

			<div class="resto-container col-12 col-sm-12 col-md-7 col-lg-8" id="resto-container">

				<div id="resto-content">

					<div class="row">

                        <!--RESULTS-->

						<div class="resto-col-card col-6 col-sm-4 col-md-6 col-lg-4" v-for="result in prettyResults" :key="result.objectID" :class="result.isGastronomic ? 'gold' : ''">
							<div class="card resto-card">

								<!-- <div v-if="isauth" class="resto-like">
									<svg viewBox="0 0 26 24">
										<g stroke-width="1">
											<g transform="translate(-10.000000, -12.000000)">
												<path d="M22.9280429,16.8197164 C23.898226,14.5253564 26.1109875,12.9197843 28.6843427,12.9197843 C32.1504824,12.9197843 34.646439,15.8867327 34.9608335,19.4212711 C34.9608335,19.4212711 35.1318305,20.2978559 34.759237,21.8776284 C34.2504459,24.0291909 33.0576666,25.9413577 31.4472947,27.3993323 L22.9280429,35 L14.5539887,27.3993323 C12.9436167,25.9413577 11.7508375,24.0291909 11.2420463,21.8776284 C10.8694528,20.2978559 11.0380499,19.4212711 11.0380499,19.4212711 C11.3524444,15.8843327 13.8508009,12.9197843 17.3169406,12.9197843 C19.8902958,12.9197843 21.9602598,14.5253564 22.9280429,16.8197164"></path>
											</g>
										</g>
									</svg>
								</div> -->

								<a :href="result.url" @mouseenter="handleHover(result.objectID)" @mouseleave="handleLeave(result.objectID)">
									<div class="shadow">
										<img-loader
											v-if="result.thumb"
											class="card-img-top"
											alt="Thumbnail"
											:src="result.thumb"
										></img-loader>
										<img v-else src="/img/resto/resto-temp.jpg" alt="Thumbnail" class="card-img-top">
									</div>
									<div class="card-body">
										<div class="head">
											<h4 class="card-title" v-html="result.name"></h4>
											<h5 class="resto-kitchen" v-html="result.kitchens.slice(0, 3).join(', ')"></h5>
										</div>
										<div class="promo" v-if="result.open && (result.day.am.promotion || result.day.pm.promotion)">
											<div class="noon" v-if="result.day.am.promotion">
												<span class="color-pass">-{{ result.day.am.promotion }}%</span> {{ trans.get('resto-details.noon') }}
											</div>
											<div class="eve" v-if="result.day.pm.promotion">
												<span class="color-pass">-{{ result.day.pm.promotion }}%</span> {{ trans.get('resto-details.eve') }}
											</div>
										</div>
										<div class="promo" v-else-if="result.open && !result.day.am.promotion && !result.day.pm.promotion">
											<div class="color-pass">{{ trad.nopromo }}</div>
										</div>
										<div class="promo" v-if="!result.open">
											<div class="color-pass">{{ trad.close }}</div>
										</div>
									</div>
								</a>
							</div>
						</div>

						<div class="map-btn d-block d-md-none" v-on:click="mapToggle = !mapToggle">
							<svg v-if="!mapToggle" width="20px" height="29px" viewBox="0 0 20 29" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
							    <g id="Symbols" stroke="none" stroke-width="1" fill-rule="evenodd">
							        <g id="Page-1">
							            <g id="Clip-2"></g>
							            <path d="M9.5266,14.7463 C6.5006,14.7463 4.0476,12.2933 4.0476,9.2623 C4.0476,6.2343 6.5006,3.7853 9.5266,3.7853 C12.5506,3.7853 15.0076,6.2343 15.0076,9.2623 C15.0076,12.2933 12.5506,14.7463 9.5266,14.7463 M9.5696,0.0003 C4.2856,0.0003 0.0006,4.2583 0.0006,9.5083 C0.0006,12.1953 2.6366,17.0083 2.6366,17.0083 L9.2186,28.1763 L16.0866,17.1373 C16.0866,17.1373 19.1366,12.5473 19.1366,9.5083 C19.1406,4.2583 14.8546,0.0003 9.5696,0.0003" id="Fill-1" mask="url(#mask-2)"></path>
							        </g>
							    </g>
							</svg>


							<svg v-else aria-hidden="true" role="img" style="width: 28px; height: 28px; margin-top: 15px;" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
								<path d="M296 32h192c13.255 0 24 10.745 24 24v160c0 13.255-10.745 24-24 24H296c-13.255 0-24-10.745-24-24V56c0-13.255 10.745-24 24-24zm-80 0H24C10.745 32 0 42.745 0 56v160c0 13.255 10.745 24 24 24h192c13.255 0 24-10.745 24-24V56c0-13.255-10.745-24-24-24zM0 296v160c0 13.255 10.745 24 24 24h192c13.255 0 24-10.745 24-24V296c0-13.255-10.745-24-24-24H24c-13.255 0-24 10.745-24 24zm296 184h192c13.255 0 24-10.745 24-24V296c0-13.255-10.745-24-24-24H296c-13.255 0-24 10.745-24 24v160c0 13.255 10.745 24 24 24z" class=""></path>
							</svg>
						</div>

					</div>

                    <div class="row">
						<div class="col center" v-if="!noResult && !stopShowMore">
							<a href="" class="btn btn-white mt-5" @click.prevent="showMore">{{ trad.show_more }}</a>
						</div>
						<div class="col center" v-else-if="noResult">
							<h3 class="content-title mt-5">{{ trad.no_result }}</h3>
						</div>
                    </div>

				</div>

				<slot name="footer"></slot>

			</div>

			<div class="map-container col-12 col-sm-12 col-md-5 col-lg-4" v-bind:class="{ 'maptoggle': mapToggle }">

				<rmap
                    ref="map"
                    :places="mapPlaces"
                    :current-position="position"
                    :item-link="itemLink"
                    :zoommap="18"
                    :resetmap="true"
                    :button_text="trad.button_text"
                    :button_title="trad.button_title"
                    style="width: 100%; height: 100%"
                    :auto-fit="!boxRefined"
					:lang="lang"
				></rmap>

			</div>

		</div>
	</div>
</template>

<script>
    import moment from 'moment'
    import Datepicker from 'vuejs-datepicker'
	import instantsearch from 'instantsearch.js'

	import { connectInfiniteHits } from 'instantsearch.js/es/connectors'
    import { connectMenu } from 'instantsearch.js/es/connectors'
    import { connectClearAll } from 'instantsearch.js/es/connectors'

	import {
		searchBox as searchBoxWidget
	} from 'instantsearch.js/es/widgets'

	import Geolocation from '../modules/Geolocation'
	import UrlParser from '../modules/UrlParser'

	import Lang from 'lang.js';
	import translations from '../vue-translations'

	export default {

		components: {
			Datepicker,
		},

		props: [
            'algoliaId',
            'algoliaKey',
            'itemLink',
		    'indice',
            'trad',
            'isauth',
			'lang',
        ],

		data() {

			return  {
				trans: null,
				placesIndex: null,

				results: [],
                showMore: null,
				noResult: false,
				stopShowMore: false,
				perPage: 30,

				kitchenFacets: [],
                kitchenRefine: null,

                gastronomicFacets: [],
                gastronomicRefine: null,

                promoFilter: null,

                clearAll: null,

				preciseLoc: false,
				position: null,
                boxRefined: false,

				placeholder: this.trad.placeholder,

				mapToggle: false,
				footerToggle: false,
				expanded: false,

				selectedDate: moment().locale(this.lang).format('YYYY-MM-DD'),
				showDate: '',
                dayOfWeek: null,
			}
		},

        computed: {

		    prettyResults() {

		        return this.results.map((result) => {

		            result.name = result._highlightResult.name.value
                    result.url = this.itemLink.replace('%slug%', result.slug)
                    result.distance = (result._rankingInfo.geoDistance / 1000).toFixed(1) + 'km'
                    result.day = result.schedule[this.dayOfWeek]
                    result.open = result.day.am.open || result.day.pm.open

					result.kitchens.map((kitchen, i) => {
						result.kitchens[i] = this.trans.get('resto-details.'+kitchen)
			            return this.trans.get('resto-details.'+kitchen)
	                })

		            return result
                })

            },

		    mapPlaces() {
                return this.results.map((result) => {
					result.kitchens.map((kitchen, i) => {
						result.kitchens[i] = this.trans.get('resto-details.'+kitchen)
			            return this.trans.get('resto-details.'+kitchen)
	                })
                    return {
                        name: result.name,
                        slug: result.slug,
                        geolocation: result._geoloc,
                        isGold: result.isGastronomic,
                        id: result.objectID,
                        address: result.address,
                        kitchens: result.kitchens.join(', ')
                    }
                })
            }

        },

		mounted() {
			// Benji
			this.setNavHeight()
			window.addEventListener('resize', this.setNavHeight);
			// Localization
			const lang = new Lang()
			this.trans = lang
			this.trans.setLocale(this.lang)
			this.trans.setMessages(translations)

			// Init Search
			this.initSearch()
		},

		methods: {

			resetFiltersAndCollapse() {
				this.hideCollapse()
				this.resetFilters()
			},

			hideCollapse() {
				this.$root.$emit('bv::toggle::collapse','filter_collapse')
			},

			initSearch() {

				this.placesIndex = instantsearch({
					appId: this.algoliaId,
					apiKey: this.algoliaKey,
					indexName: this.indice,
					searchParameters: {
						hitsPerPage: this.perPage,
						getRankingInfo: true,
                        highlightPreTag: '<span class="search-highlight">',
                        highlightPostTag: '</span>',
                        restrictSearchableAttributes: ['name'],
					}
				})

				this.initSearchBox()
                this.initInfiniteHits()
                this.initGeoSearch()
                this.initKitchensMenu()
                this.initGastonomicMenu()
                this.initPromoMenu()
                this.initClearAll()

                // Start
				this.placesIndex.start()
			},

            // SEARCH BOX
            initSearchBox() {

                let container = document.getElementById('places-search');
                let display = container.currentStyle ? container.currentStyle.display : getComputedStyle(container, null).display;
                let elemId = display === 'block' ? 'searchBoxMobile' : 'searchBox';
                let elem = document.getElementById(elemId);

                let searchBox = searchBoxWidget({
                    container: elem,
                    magnifier: false,
                    wrapInput: false,
                    reset: false
                });

                elem.addEventListener('keydown', () => {
                    this.disableMapRefine()
                })

                this.placesIndex.addWidget(searchBox);
            },

            // HITS

            initInfiniteHits() {

                let hits = connectInfiniteHits((params, first) => {

					if(params.hits.length === 0) {
						this.noResult = true // On affiche "aucun résultat"
					} else if(params.hits.length % this.perPage !== 0) {
						this.stopShowMore = true // On affiche pas le bouton "show more"
						this.noResult = false // On affiche pas "aucun résultat"
					} else {
						this.stopShowMore = false // On affiche le bouton "show more"
						this.noResult = false // On affiche pas "aucun résultat"
					}

                    if(first)
                        this.showMore = params.showMore

                    this.results = params.hits
                })

                this.placesIndex.addWidget(hits())
            },

            // GEOSEARCH
            initGeoSearch() {

                this.placesIndex.addWidget({

                    init: (opts) => {

                        const helper = opts.helper

						if(UrlParser.hasParams(window.location.href, ['lat', 'lng'])) {
                            this.preciseLoc = true
                            const {params} = UrlParser.parse(window.location.href)
                            helper.setQueryParameter('aroundLatLng', params.lat + ', ' + params.lng)
                            helper.setQueryParameter('aroundRadius', 10000)
						} else {
                            this.initClassicGeoloc(helper)
						}

                        // Listen Map User Interaction
                        this.$refs.map.$on('afterUserUpdate', () => {
                            this.enableMapRefine();
                        })
                    }

                })
            },

			initClassicGeoloc(helper) {

                // Start With Around IP Position
                helper.setQueryParameter('aroundLatLngViaIP', true)

                // Launch Browser Geolocation
                Geolocation.localize().then((position) => {
                    this.preciseLoc = true
                    this.position = position

                    // Switch To Around Browser Position
                    helper.setQueryParameter('aroundLatLngViaIP', false)
                    helper.setQueryParameter('aroundLatLng', this.position.lat + ', ' + this.position.lng)
                    helper.search()
                })
			},

            enableMapRefine() {

                // Define Search Bounds
                const bounds = this.$refs.map.getBounds()

                const box = [
                    bounds.getNorthEast().lat(),
                    bounds.getSouthWest().lng(),
                    bounds.getSouthWest().lat(),
                    bounds.getNorthEast().lng(),
                ]

                this.boxRefined = true
                this.placesIndex.helper.setQueryParameter('hitsPerPage', 10000)
                this.placesIndex.helper.setQueryParameter('insideBoundingBox', [box])
                this.placesIndex.helper.search()
            },

            disableMapRefine() {
                this.boxRefined = false
                this.placesIndex.helper.setQueryParameter('hitsPerPage', this.perPage)
                this.placesIndex.helper.setQueryParameter('insideBoundingBox', undefined)
            },

            // KITCHENS
            initKitchensMenu() {

                let menu = connectMenu((params, first) => {
                    if(first)
                        this.kitchenRefine = params.refine

					params.items.map((kitchen, i) => {
						params.items[i].label = this.trans.get('resto-details.'+kitchen.label)
			            return this.trans.get('resto-details.'+kitchen)
	                })

                    this.kitchenFacets = params.items
                })

                this.placesIndex.addWidget(menu({
                    attributeName: 'kitchens',
                    limit: 1000
                }))
            },

            applyKitchenFilter(e) {
                this.disableMapRefine()
                this.kitchenRefine(e.target.value)
            },

            // GASTRONOMIC
            initGastonomicMenu() {

                let menu = connectMenu((params, first) => {
                    if(first)
                        this.gastronomicRefine = params.refine

                    this.gastronomicFacets = params.items
                })

                this.placesIndex.addWidget(menu({
                    attributeName: 'gastronomic',
                    limit: 1000
                }))
            },

            applyGastronomicFilter(e) {
                this.disableMapRefine()
                this.gastronomicRefine(e.target.value)
            },

            // PROMO
            initPromoMenu() {
                this.placesIndex.addWidget({
                    init: (opts) => {

                        const helper = opts.helper
                    	const input1 = this.$refs.promoSelect1
						input1.addEventListener('change', (e) => {
                            this.disableMapRefine()
                            this.refinePromo()
                        })
						const input2 = this.$refs.promoSelect2
                        input2.addEventListener('change', (e) => {
                            this.disableMapRefine()
                            this.refinePromo()
                        })
                    }
                })
            },

            refinePromo() {

			    let helper = this.placesIndex.helper

                if(this.promoFilter) {
                    helper.setQueryParameter('numericFilters',
                        'schedule.'+this.dayOfWeek+'.am.promotion >= ' + this.promoFilter + ' OR schedule.'+this.dayOfWeek+'.pm.promotion >= ' + this.promoFilter)
                } else {
                    helper.setQueryParameter('numericFilters', '')
                }

                helper.search()
            },

            // CLEAR ALL
            initClearAll() {
                let clear = connectClearAll((params, first) => {
                    if(first)
                        this.clearAll = params.refine
                })

                this.placesIndex.addWidget(clear())
            },

            resetFilters() {

			    // Reset Map
                this.disableMapRefine()
                this.placesIndex.helper.search()

			    // Reset Promo
                this.promoFilter = null
                this.refinePromo()

                // Reset Facets
                this.clearAll()
            },

            handleHover(id) {
			    // this.$refs.map.hoverMarker(id)
            },

            handleLeave(id) {
                // this.$refs.map.leaveMarker(id)
            },

            // BENJI
            setNavHeight() {
				if(document.getElementById('filter_collapse').classList.contains('show')) {
					this.hideCollapse()
				}
                document.getElementById('filter-nav').style.height = (window.innerHeight-116) + 'px'
            },

			customFormatter(date) {
			    const mDate = moment(date).locale(this.lang)

				this.selectedDate = mDate.format('YYYY-MM-DD')
				this.showDate = mDate.format('ddd D MMM')
                this.dayOfWeek = mDate.isoWeekday()

				return this.selectedDate
			},

			openCalendar() {
				this.$refs.restoSearchCalendar.showCalendar()
			},

		}

	}

</script>



// WEBPACK FOOTER //
// resources/assets/js/components/PlacesSearch.vue